import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAffiliateAttributionFromSearch } from "../utils/affiliateAttribution";
import { isAffiliateAttributionEnabled } from "../utils/affiliateRollout";
import { trackAffiliateLinkVisit } from "../utils/affiliateLinkVisit";

function AffiliateAttributionBootstrapper() {
  const location = useLocation();

  useEffect(() => {
    if (!isAffiliateAttributionEnabled()) return;
    captureAffiliateAttributionFromSearch(location.search, {
      pathname: location.pathname,
    });
    void trackAffiliateLinkVisit(location.search);
  }, [location.pathname, location.search]);

  return null;
}

export default AffiliateAttributionBootstrapper;
